import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import toy from "../../assets/toy.png";
import bag from "../../assets/bag.png";
import language from "../../assets/language.png";
import pen from "../../assets/pen.png";
import  './FeaturesSection.css'
function FeaturesSection() {
    const { currentLocal } = useSelector((state) => state.currentLocal);
  
  return (
    <section className='py-5 'style={{backgroundColor:"#faf7f3"}}>
      <Container>
        <Row>
<span className='w-text-content'>{currentLocal.home.ourServices}</span>
<span className='w-subtitle'>{currentLocal.home.Leading}</span>
        </Row>
        <Row className='mt-5'>
<Col md={3}>
<div className='feature_card rounded px-3 py-4'>
  <div className='d-flex justify-content-center mb-4'>
    <img src={toy}alt=''className='w-50'/>
  </div>
<h4 className='feature_card_title'>{currentLocal.home.Kindergarten}</h4>
<p style={{whiteSpace: 'pre-line',lineHeight:"32px",color:"rgb(133,133,133)"}}>{currentLocal.home?.KindergartenContent?.slice(0,268)}</p>
</div>
</Col>
<Col md={3}>
<div className='feature_card rounded px-3 py-4'>
  <div className='d-flex justify-content-center mb-4'>
    <img src={bag}alt=''className='w-50'/>
  </div>
<h4 className='feature_card_title'>{currentLocal.home.BasicSection}</h4>
<p style={{whiteSpace: 'pre-line',lineHeight:"32px",color:"rgb(133,133,133)"}}>{currentLocal.home.KindergartenContent.slice(0,268)}</p>
</div>
</Col>
<Col md={3}>
<div className='feature_card rounded px-3 py-4'>
  <div className='d-flex justify-content-center mb-4'>
    <img src={pen}alt=''className='w-50'/>
  </div>
<h4 className='feature_card_title'>{currentLocal.home.PostBasicection}</h4>
<p style={{whiteSpace: 'pre-line',lineHeight:"32px",color:"rgb(133,133,133)"}}>{currentLocal.home.KindergartenContent.slice(0,268)}</p>
</div>
</Col>
<Col md={3}>
<div className='feature_card rounded px-3 py-4'>
  <div className='d-flex justify-content-center mb-4'>
    <img src={language}alt=''className='w-50'/>
  </div>
<h4 className='feature_card_title'>{currentLocal.home.BilingualSection}</h4>
<p style={{whiteSpace: 'pre-line',lineHeight:"32px",color:"rgb(133,133,133)"}}>{currentLocal.home.KindergartenContent.slice(0,268)}</p>
</div>
</Col>
        </Row>
      </Container>
    </section>
  )
}

export default FeaturesSection